module.exports = __webpack_public_path__ + "img/palmar-resort-4.82eb8287.jpg";